import { FC } from 'react';
import styles from '../styles/layout/row.module.scss';

const Row: FC = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default Row;
